import { apiEndpoint } from "@/configs/api/api-configs";
import { reactive } from "@vue/composition-api";

export default function flashdealCampaignModel() {
  const fetchFlashDealCampaignList = reactive({
    api: `${apiEndpoint.bcrm_platform}/campaign/list`,
    method: "POST",
    payload: {
      Page: 1,
      Limit: 10,
      Filters: [],
    },
  });

  const fetchFlashDealCampaignDetail = reactive({
    api: `${apiEndpoint.bcrm_platform}/campaign/detail`,
    method: "POST",
    payload: {
      Campaign_Id: 0,
    },
  });

  const fetchFlashDealCampaignEdit = reactive({
    api: `${apiEndpoint.bcrm_platform}/campaign/edit`,
    method: "POST",
    payload: {
      Campaign_Id: 0,
      Campaign_Name_Th: "",
      Campaign_Name_En: "",
      Campaign_Image_Url: "",
      Description_Th: "",
      Description_En: "",
      Section: "",
      Valid_From: "",
      Valid_From_Time: "",
      Valid_Through: "",
      Valid_Through_Time: "",
      Status: "",
    },
  });

  const fetchFlashDealCampaignCreate = reactive({
    api: `${apiEndpoint.bcrm_platform}/campaign/create`,
    method: "POST",
    payload: {
      Campaign_Name_Th: "",
      Campaign_Name_En: "",
      Campaign_Image_Url: "",
      Description_Th: "",
      Description_En: "",
      Section: "",
      Valid_From: "",
      Valid_From_Time: "",
      Valid_Through: "",
      Valid_Through_Time: "",
      Status: "",
    },
  });

  const fetchFlashDealCampaignRemove = reactive({
    api: `${apiEndpoint.bcrm_platform}/campaign/remove`,
    method: "POST",
    payload: {
      CampaignId: 0,
    },
  });

  const fetchFlashDealCampaignChangeStatus = reactive({
    api: `${apiEndpoint.bcrm_platform}/campaign/changestatus`,
    method: "POST",
    payload: {
      CampaignId: 0,
      Status: 5,
    },
  });

  return {
    fetchFlashDealCampaignList,
    fetchFlashDealCampaignDetail,
    fetchFlashDealCampaignEdit,
    fetchFlashDealCampaignCreate,
    fetchFlashDealCampaignRemove,
    fetchFlashDealCampaignChangeStatus,
  };
}
